module.exports = __webpack_public_path__ + "static/media/red-tag-sale-confirmation-background-mobile.48ba72b1.webp";